import { registerChatArtifactPreviewComponent } from '@oui/app-core/src/components/ChatArtifactPreview';
import { registerChatInputArtifactHandler } from '@oui/app-core/src/components/ChatInputArtifact';

import { StressBreathingIndex } from './screens';

registerChatArtifactPreviewComponent('BreathHolding', () => StressBreathingIndex);
registerChatArtifactPreviewComponent('Hyperventilation', () => StressBreathingIndex);
registerChatInputArtifactHandler('BreathHolding', async ({ navigate, startArtifactRequest }) => {
  startArtifactRequest('BreathHolding');
  navigate('StressBreathingIndex', { type: 'holding' });
});
registerChatInputArtifactHandler('Hyperventilation', async ({ navigate, startArtifactRequest }) => {
  startArtifactRequest('Hyperventilation');
  navigate('StressBreathingIndex', { type: 'hyperventilation' });
});

export * from './screens';
export * from './components';
export * from './hooks';
export * from './types/navigation';
export * from './register';
